import 'pikaday/css/pikaday.css'
import moment from 'moment-timezone'
import i18n from './i18nHelpers'
import Pickaday from 'pikaday'
import serviceHelpers from '../helpers/serviceHelpers'

function convertDate (value) {
  if (value) {
    const arr = value.split('/')
    return arr[2] + '-' + arr[1] + '-' + arr[0]
  }
  return null
}

let picker = null

const VuePikaday = {
  bind (el, ref) {
    const calendarData = ref.value
    moment.tz.setDefault('Asia/Bangkok')
    const calendarLang = {
      previousMonth: i18n.t('message.calendar.last_month'),
      nextMonth: i18n.t('message.calendar.next_month'),
      months: [i18n.t('message.calendar.month.01'), i18n.t('message.calendar.month.02'), i18n.t('message.calendar.month.03'), i18n.t('message.calendar.month.04'), i18n.t('message.calendar.month.05'), i18n.t('message.calendar.month.06'), i18n.t('message.calendar.month.07'), i18n.t('message.calendar.month.08'), i18n.t('message.calendar.month.09'), i18n.t('message.calendar.month.10'), i18n.t('message.calendar.month.11'), i18n.t('message.calendar.month.12')],
      weekdays: [i18n.t('message.calendar.week.01'), i18n.t('message.calendar.week.02'), i18n.t('message.calendar.week.03'), i18n.t('message.calendar.week.04'), i18n.t('message.calendar.week.05'), i18n.t('message.calendar.week.06'), i18n.t('message.calendar.week.07')],
      weekdaysShort: [i18n.t('message.calendar.week_short.01'), i18n.t('message.calendar.week_short.02'), i18n.t('message.calendar.week_short.03'), i18n.t('message.calendar.week_short.04'), i18n.t('message.calendar.week_short.05'), i18n.t('message.calendar.week_short.06'), i18n.t('message.calendar.week_short.07')]
    }

    const currentHour = moment().hour() // => 9
    let numDay = (currentHour >= 20) ? 2 : 1
    if (calendarData.isToday) {
      numDay = (currentHour >= 20) ? 1 : 0
    }

    const today = moment().add(numDay, 'days')
    picker = new Pickaday({
      field: el,
      i18n: calendarLang,
      minDate: today.toDate(),
      format: 'DD/MM/YYYY',
      onSelect () {
        const newDate = new Date(picker._d)
        let d = newDate.getDate()
        let m = newDate.getMonth() + 1

        if (d < 10) {
          d = '0' + d
        }

        if (m < 10) {
          m = '0' + m
        }

        const pickDate = d + '/' + m + '/' + newDate.getFullYear()
        el.value = pickDate
        ref.value.date = pickDate
      }
    })
    picker.setDate(convertDate(calendarData.date))
  },
  update (el, ref) {
    const calendarData = ref.value
    const currentHour = moment().hour() // => 9
    // TODO::Check isToday to init start date of date picker
    let sameDayBookingConfig = calendarData.sameDayBookingConfig
    // // check type of service
    if (calendarData.serviceId && sameDayBookingConfig.services) {
      sameDayBookingConfig = serviceHelpers.getSameDayService(sameDayBookingConfig, calendarData.serviceId, calendarData.provinceId)
    }
    if (sameDayBookingConfig) {
      const canBookToHour = sameDayBookingConfig.can_book_to_hour
      let numDay = 1
      if (sameDayBookingConfig.can_book_same_day) {
        numDay = 0
        if (!calendarData.isToday) {
          numDay = sameDayBookingConfig.num_next_day
        }
      } else {
        numDay = (sameDayBookingConfig.num_next_day) ? sameDayBookingConfig.num_next_day : 1
      }
      if (currentHour >= canBookToHour) {
        numDay += 1
      }
      const today = moment().add(numDay, 'days')
      picker.setMinDate(today.toDate())
      picker.setDate(convertDate(calendarData.date))
    }
  }
}

export default VuePikaday



// WEBPACK FOOTER //
// ./src/helpers/pickadayBooking.js